export default __webpack_public_path__ + "static/media/HDTX_LKTT 2024.56602f23.pdf";